const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

export const adminApi = {
    setupTwoFactor: async (): Promise<{ secret: string; qrCode: string }> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/2fa/setup`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al configurar 2FA');
        }

        return response.json();
    },

    enableTwoFactor: async (secret: string, code: string): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/2fa/enable`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ secret, code })
        });

        if (!response.ok) {
            throw new Error('Código 2FA inválido o error en la activación');
        }
    },

    disableTwoFactor: async (): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/2fa/disable`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al desactivar 2FA');
        }
    },

    getStats: async (): Promise<any> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/stats`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al obtener estadísticas');
        }

        return response.json();
    },

    getAuditLogs: async (): Promise<any[]> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/audit-logs`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al obtener logs de auditoría');
        }

        return response.json();
    },

    getUsers: async (query?: string): Promise<any[]> => {
        const token = localStorage.getItem('token');
        const url = `${API_URL}/admin/users${query ? `?query=${encodeURIComponent(query)}` : ''}`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al obtener usuarios');
        }

        return response.json();
    },

    updateUserStatus: async (userId: string, active: boolean): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/users/${userId}/status`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ active })
        });

        if (!response.ok) {
            throw new Error('Error al actualizar estado del usuario');
        }
    },

    updateUserRole: async (userId: string, role: string): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/users/${userId}/role`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ role })
        });

        if (!response.ok) {
            throw new Error('Error al actualizar rol del usuario');
        }
    },
    
    impersonateUser: async (userId: string): Promise<any> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/users/${userId}/impersonate`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al iniciar sesión como este usuario');
        }

        return response.json();
    },

    getRoles: async (): Promise<any[]> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/roles`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al obtener roles');
        return response.json();
    },

    getPermissions: async (): Promise<any[]> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/permissions`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) throw new Error('Error al obtener permisos');
        return response.json();
    },

    createRole: async (role: any): Promise<any> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/roles`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(role)
        });
        if (!response.ok) throw new Error('Error al crear rol');
        return response.json();
    },

    updateRolePermissions: async (roleId: string, permissionIds: string[]): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/admin/roles/${roleId}/permissions`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(permissionIds)
        });
        if (!response.ok) throw new Error('Error al actualizar permisos del rol');
    }
};
